import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const Healthcare = () => {
  return <PageTemplate title="Healthcare Solutions" subtitle="Medical Technology & AI" breadcrumb="Industries > Healthcare"><div className="content-section"><p>Healthcare software, medical AI, and biotechnology solutions.</p></div></PageTemplate>;
};
export default Healthcare; 